import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import erpFetcher from "@/common/fetchErpnextServices";
var UpdateSellTradeInfo = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var request_id, city_id, inspection_location_type, inspection_location_name, area_id, location_freetext, offer_price_status, customer_rating, rejection_reason, reject_reason_other_text, latitude, longitude, map_link, allParams, params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          request_id = _ref.request_id, city_id = _ref.city_id, inspection_location_type = _ref.inspection_location_type, inspection_location_name = _ref.inspection_location_name, area_id = _ref.area_id, location_freetext = _ref.location_freetext, offer_price_status = _ref.offer_price_status, customer_rating = _ref.customer_rating, rejection_reason = _ref.rejection_reason, reject_reason_other_text = _ref.reject_reason_other_text, latitude = _ref.latitude, longitude = _ref.longitude, map_link = _ref.map_link;
          allParams = {
            request_id: request_id,
            city_id: city_id,
            inspection_location_type: inspection_location_type,
            inspection_location_name: inspection_location_name,
            area_id: area_id,
            location_freetext: location_freetext,
            offer_price_status: offer_price_status,
            customer_rating: customer_rating,
            rejection_reason: rejection_reason,
            reject_reason_other_text: reject_reason_other_text,
            latitude: latitude,
            longitude: longitude,
            map_link: map_link
          };
          params = Object.fromEntries(Object.entries(allParams).filter(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
              _ = _ref4[0],
              value = _ref4[1];
            return value !== undefined && value !== null;
          })); //@ts-ignore
          _context.n = 1;
          return erpFetcher(null, true).post('sell-trade/update-sell-trade', params);
        case 1:
          res = _context.v;
          return _context.a(2, res || null);
      }
    }, _callee);
  }));
  return function UpdateSellTradeInfo(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default UpdateSellTradeInfo;